import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppShell } from "../components/Nav";
import { getToken } from "../lib/auth";

export default function RoundChallenge() {
  const [loading, setLoading] = useState(true);
  const [round, setRound] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const token = getToken();

    fetch("/api/journey/current-round", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        setRound(data);
        setLoading(false);
      })
      .catch(() => {
        setRound(null);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!round?.started_at || !round?.duration) return;

    const startedAt = new Date(round.started_at).getTime();
    const durationMs = Number(round.duration) * 1000;

    const tick = () => {
      const remaining = Math.max(0, startedAt + durationMs - Date.now());
      setTimeLeft(remaining);
    };

    tick();
    const timer = setInterval(tick, 1000);

    return () => clearInterval(timer);
  }, [round]);

  const secondsLeft = timeLeft === null ? null : Math.ceil(timeLeft / 1000);
  const isUrgent = secondsLeft !== null && secondsLeft <= 10;

  return (
    <AppShell>
      <div className="px-6 md:px-12 py-10 md:py-14">
        <h1 className="font-display text-4xl md:text-6xl mb-6">
          Your round
        </h1>

        {loading && (
          <div className="text-white/60">Loading your round...</div>
        )}

        {!loading && !round && (
          <div className="glass rounded-2xl p-8 text-center">
            <h2 className="text-xl mb-3">Your journey has not started yet</h2>
            <p className="text-white/60 mb-6">
              Complete your selections to begin your rounds.
            </p>
            <Link
              to="/select-seven"
              className="rounded-full bg-gradient-gold px-6 py-3 text-black font-semibold"
            >
              Start your journey
            </Link>
          </div>
        )}

        {!loading && round && (
          <div className="glass rounded-2xl p-8 text-center">
            <h2 className="text-xl mb-3">{round.name || "Current round"}</h2>
            <p className="text-white/60 mb-6">Continue your journey.</p>
            <Link
              to="/head-to-head"
              className="rounded-full border border-white/20 px-6 py-3"
            >
              Continue
            </Link>
          </div>
        )}
      </div>
    </AppShell>
  );
}
